const ctaProductCustom = document.querySelector(".container-cta-product-custom");

const SOLD_OUT_CONTACT_URL = "https://quatrojoyas.com/pages/contactanos";
const SOLD_OUT_CONTACT_LABEL = "Contáctanos";
const PREVIEW_IMAGE_UPLOAD_URL = "https://product-image-preview.syntaxter.workers.dev/api/save-file";
const PREVIEW_IMAGE_PROPERTY_NAME = "properties[_Vista previa]";
const PREVIEW_UPLOADING_LABEL = "Subiendo vista previa…";
const PREVIEW_UPLOAD_ERROR_MESSAGE = "No se pudo subir la vista previa. Inténtalo de nuevo.";
let isUploadingPreviewImage = false;

const SIDE_FIELD_FONT_VARIANTS = [
    {
        id: "font-1",
        name: "Libre Baskerville",
        previewFamily: '"Libre Baske    rville", serif',
        previewStyle: "normal"
    },
    {
        id: "font-2",
        name: "Comfortaa",
        previewFamily: '"Comfortaa", sans-serif',
        previewStyle: "normal"
    },
    {
        id: "font-3",
        name: "Arapey",
        previewFamily: '"Arapey", serif',
        previewStyle: "italic"
    }
];

const DEFAULT_SIDE_FIELD_FONT_FAMILY = SIDE_FIELD_FONT_VARIANTS[0].previewFamily;
const DEFAULT_SIDE_FIELD_FONT_STYLE = SIDE_FIELD_FONT_VARIANTS[0].previewStyle;
const COMFORTAA_FONT_VARIANT_ID = "font-2";
const SIDE_FIELD_SYMBOL_FONT_FAMILY = "icomoon";
// Orden visual: infinito, corazón, huella, cruz, estrella, ancla (IcoMoon e902, e900, e901, e903, e904, e905)
const SIDE_FIELD_SYMBOLS = ["\uE902", "\uE900", "\uE901", "\uE903", "\uE904", "\uE905"];
const SIDE_FIELD_SYMBOL_LABELS = {
    "\uE902": "Infinito",
    "\uE900": "Corazón",
    "\uE901": "Huella",
    "\uE903": "Cruz",
    "\uE904": "Estrella",
    "\uE905": "Ancla"
};
// Códigos seguros para cart line / admin de Shopify (el cliente sigue viendo el icono en el input).
const SIDE_FIELD_SYMBOL_SHOPIFY_CODES = {
    "\uE902": "I",
    "\uE900": "C",
    "\uE901": "H",
    "\uE903": "X",
    "\uE904": "S",
    "\uE905": "A"
};
const SIDE_FIELD_SHOPIFY_CODE_SYMBOLS = {
    I: "\uE902",
    C: "\uE900",
    H: "\uE901",
    X: "\uE903",
    S: "\uE904",
    A: "\uE905",
    // Compatibilidad con pedidos anteriores que usaban "P" (pez)
    P: "\uE903"
};
const SIDE_FIELD_MAX_LENGTH = 9;
let sharedSideFieldFontVariantId = SIDE_FIELD_FONT_VARIANTS[0].id;

function withSymbolFont(fontFamily) {
    const family = String(fontFamily || DEFAULT_SIDE_FIELD_FONT_FAMILY).trim() || DEFAULT_SIDE_FIELD_FONT_FAMILY;
    if (family.toLowerCase().includes(SIDE_FIELD_SYMBOL_FONT_FAMILY)) {
        return family;
    }
    return `"${SIDE_FIELD_SYMBOL_FONT_FAMILY}", ${family}`;
}

if (ctaProductCustom) {
    ctaProductCustom.addEventListener("click", openSettingForMemoir);
}

document.addEventListener("click", (event) => {
    const personalizeButton = event.target && event.target.closest ? event.target.closest(".container-cta-product-custom") : null;
    if (!personalizeButton) {
        return;
    }

    openSettingForMemoir.call(personalizeButton);
});

requestAnimationFrame(() => {
    ensureSoldOutWhatsAppForPage();
    enhanceSideFieldPropertyDisplays(document);

    const bcpo = document.getElementById("bcpo");
    if (!bcpo) {
        return;
    }

    ensureSideLabelSuffixHidden(bcpo);
    ensurePropertyInputsNearSymbolControl(bcpo);
    ensureSideFieldFeedback(bcpo);
    ensureFontSelectorsNearSideLabels(bcpo);
    ensureBcpoFontSelectHiddenAndSynced(bcpo);
    ensureIconSelectorsNearSideFields(bcpo);
    ensureSideFieldShopifyMirrors(bcpo);
    ensureActionsBeforeInput(bcpo);
    updateAddToCartVisibility(bcpo);
});


function openSettingForMemoir(){
    const button = document.querySelector(".container-cta-product-custom");

    if (!button) {
        return;
    }

    button.style.display = "none";

    const productForm = button.closest("form");
    const addToCartButton = productForm ? productForm.querySelector("[data-product-atc]") : null;
    if (addToCartButton && isAddToCartSoldOut(addToCartButton)) {
        setAddToCartEnabled(addToCartButton, false);
    }

    const bcpo = document.getElementById('bcpo');
    if (bcpo) {
        bcpo.style.display = "block";
        mountPreviewBeforeBcpo(bcpo, true);
        ensureSideLabelSuffixHidden(bcpo);
        ensurePropertyInputsNearSymbolControl(bcpo);
        ensureSideFieldFeedback(bcpo);
        ensureFontSelectorsNearSideLabels(bcpo);
        ensureBcpoFontSelectHiddenAndSynced(bcpo);
        ensureIconSelectorsNearSideFields(bcpo);
        ensureSideFieldShopifyMirrors(bcpo);
        ensureActionsBeforeInput(bcpo);
        bindPreviewOnSymbolInteraction(bcpo);
        updateAddToCartVisibility(bcpo);
    }
}

window.openSettingForMemoir = openSettingForMemoir;


function verPersonalizacion(){
    const personalizacionFixed = document.querySelector(".personalizacion-fixed");
    if (personalizacionFixed) {
        personalizacionFixed.style.display = "block";
    }
}

function isSymbolControlElement(element) {
    if (!element) {
        return false;
    }

    const text = `${element.name || ""} ${element.id || ""} ${element.className || ""} ${element.textContent || ""}`.toLowerCase();
    return /simbolo|símbolo|symbol|corazon|corazón|corzon|heart|trebol|trébol|club|otro|other/.test(text);
}

function mountPreviewBeforeBcpo(bcpo, shouldShow = true) {
    const preview = document.querySelector(".personalizacion-fixed");
    if (!preview || !bcpo || !bcpo.parentNode) {
        return;
    }

    if (preview.nextElementSibling !== bcpo) {
        bcpo.parentNode.insertBefore(preview, bcpo);
    }

    preview.style.display = shouldShow ? "block" : "none";
}

function ensurePropertyInputsNearSymbolControl(scope) {
    if (!scope) {
        return;
    }

    const propertyNames = [
        "properties[lado 1 (texto o símbolo)]",
        "properties[lado 2 (texto o símbolo)]",
        "properties[lado 3 (texto o símbolo)]",
        "properties[lado 4 (texto o símbolo)]"
    ];

    const candidates = Array.from(scope.querySelectorAll("select, button, div, label, input[type='radio']"));
    const symbolAnchor = candidates.find((element) => isSymbolControlElement(element));
    if (!symbolAnchor) {
        return;
    }

    const insertionParent = symbolAnchor.closest(".bcpo-field, .bcpo-option, .bcpo-group, li, .form-field") || symbolAnchor.parentNode;
    if (!insertionParent) {
        return;
    }

    propertyNames.forEach((propertyName, index) => {
        const existingInput = scope.querySelector(`input[name="${propertyName}"]`);
        if (existingInput) {
            return;
        }

        const sideInput = document.createElement("input");
        sideInput.type = "text";
        sideInput.name = propertyName;
        sideInput.placeholder = `Lado ${index + 1} (texto o símbolo)`;
        sideInput.className = symbolAnchor.className || "";
        sideInput.setAttribute("data-writing-box-generated", "true");

        insertionParent.insertBefore(sideInput, symbolAnchor.nextSibling);
    });
}

function getSideFieldWrappers(scope) {
    if (!scope) {
        return [];
    }

    return Array.from(scope.querySelectorAll(".selector-wrapper, .bcpo-field, .bcpo-option, .form-field"))
        .filter((wrapper) => {
            const title = wrapper.querySelector(".bcpo-title, .bcpo-label, label");
            if (!title) {
                return false;
            }

            return /lado\s*\d+.*texto\s*o\s*s[ií]mbolo/i.test(title.textContent || "");
        });
}

function getEditableFieldFromWrapper(wrapper) {
    if (!wrapper) {
        return null;
    }

    return wrapper.querySelector("input[type='text'], textarea") || null;
}

function getFieldWrapper(field) {
    if (!field) {
        return null;
    }

    return field.closest(".selector-wrapper, .bcpo-field, .bcpo-option, .form-field") || field.parentNode;
}

function getFieldInputContainer(field) {
    if (!field) {
        return null;
    }

    return field.parentNode || getFieldWrapper(field);
}

function getLabelElementFromWrapper(wrapper) {
    if (!wrapper) {
        return null;
    }

    return wrapper.querySelector(".bcpo-label > label") || wrapper.querySelector("label") || null;
}

function getFieldLabelText(wrapper) {
    if (!wrapper) {
        return "";
    }

    const label = wrapper.querySelector(".bcpo-title, .bcpo-label, label");
    return label ? String(label.textContent || "").trim().toLowerCase() : "";
}

function ensureSideLabelSuffixHidden(scope) {
    if (!scope) {
        return;
    }

    const sideTitleNodes = Array.from(scope.querySelectorAll(".bcpo-title"))
        .filter((titleNode) => /lado\s*\d+\s*\(texto\s*o\s*s[ií]mbolo\):?/i.test(String(titleNode.textContent || "")));

    sideTitleNodes.forEach((titleNode) => {
        if (titleNode.querySelector(".bcpo-title__suffix-hidden")) {
            return;
        }

        const rawText = String(titleNode.textContent || "").trim();
        const strippedText = rawText.replace(/\s*\(texto\s*o\s*s[ií]mbolo\):?/i, "").trim();
        const updatedText = strippedText.endsWith(":") ? strippedText : `${strippedText}:`;

        titleNode.textContent = "";
        titleNode.appendChild(document.createTextNode(updatedText));

        const hiddenSuffix = document.createElement("span");
        hiddenSuffix.className = "bcpo-title__suffix-hidden";
        hiddenSuffix.textContent = " (texto o símbolo):";
        titleNode.appendChild(hiddenSuffix);
    });
}

function isOptionalBcpoWrapper(wrapper) {
    const labelText = getFieldLabelText(wrapper);
    return /comentarios|especificaciones/.test(labelText);
}

function getBcpoRequiredWrappers(scope) {
    if (!scope) {
        return [];
    }

    return Array.from(scope.querySelectorAll(".selector-wrapper, .bcpo-field, .bcpo-option, .form-field"))
        .filter((wrapper) => {
            if (isOptionalBcpoWrapper(wrapper)) {
                return false;
            }

            return Boolean(
                wrapper.querySelector("input[type='text'], textarea, select, input[type='radio'], input[type='checkbox']")
            );
        });
}

function isBcpoWrapperComplete(wrapper) {
    if (!wrapper) {
        return true;
    }

    const textField = wrapper.querySelector("input[type='text'], textarea");
    if (textField) {
        return String(textField.value || "").trim().length > 0;
    }

    const selectField = wrapper.querySelector("select");
    if (selectField) {
        if (selectField.selectedIndex <= 0) {
            return false;
        }

        return String(selectField.value || "").trim().length > 0;
    }

    const radioFields = Array.from(wrapper.querySelectorAll("input[type='radio']"));
    if (radioFields.length) {
        return radioFields.some((field) => field.checked);
    }

    const checkboxFields = Array.from(wrapper.querySelectorAll("input[type='checkbox']"));
    if (checkboxFields.length) {
        return checkboxFields.some((field) => field.checked);
    }

    return true;
}

function isAddToCartSoldOut(button) {
    if (!button) {
        return false;
    }

    if (button.getAttribute("data-sold-out") === "true") {
        return true;
    }

    const textNode = button.querySelector("[data-product-atc-text]") || button;
    const label = String(textNode.textContent || "").trim();
    return /sold\s*out|agotado/i.test(label);
}

function ensureSoldOutWhatsAppCta(button) {
    if (!button || !isAddToCartSoldOut(button)) {
        return;
    }

    const container = button.closest(".product-details__add-to-cart-buttons") || button.parentNode;
    if (!container) {
        return;
    }

    let cta = container.querySelector("[data-sold-out-whatsapp='true']");
    if (!cta) {
        cta = document.createElement("div");
        cta.className = "product-sold-out-whatsapp";
        cta.setAttribute("data-sold-out-whatsapp", "true");

        const link = document.createElement("a");
        link.className = "product-sold-out-whatsapp__button";
        link.target = "_blank";
        link.rel = "noopener noreferrer";
        cta.appendChild(link);
        button.insertAdjacentElement("afterend", cta);
    }

    const link = cta.querySelector("a");
    if (!link) {
        return;
    }

    link.href = SOLD_OUT_CONTACT_URL;
    link.textContent = SOLD_OUT_CONTACT_LABEL;
}

function ensureSoldOutWhatsAppForPage() {
    Array.from(document.querySelectorAll("[data-product-atc]")).forEach((button) => {
        if (!isAddToCartSoldOut(button)) {
            return;
        }

        button.disabled = true;
        button.setAttribute("aria-hidden", "false");
        ensureSoldOutWhatsAppCta(button);
    });
}

function setAddToCartEnabled(button, enabled) {
    if (!button) {
        return;
    }

    if (isAddToCartSoldOut(button)) {
        button.disabled = true;
        button.setAttribute("aria-hidden", "false");
        ensureSoldOutWhatsAppCta(button);
        return;
    }

    button.disabled = !enabled;
    button.setAttribute("aria-hidden", enabled ? "false" : "true");
}

function updateAddToCartVisibility(scope) {
    if (!scope) {
        return;
    }

    const form = scope.closest("form");
    const addToCartButton = form ? form.querySelector("[data-product-atc]") : null;
    if (!addToCartButton) {
        return;
    }

    if (isAddToCartSoldOut(addToCartButton)) {
        setAddToCartEnabled(addToCartButton, false);
        return;
    }

    if (isUploadingPreviewImage) {
        setAddToCartEnabled(addToCartButton, false);
        return;
    }

    const sideTextInputs = getSideFieldWrappers(scope)
        .map((wrapper) => getEditableFieldFromWrapper(wrapper))
        .filter(Boolean);
    const isComplete = sideTextInputs.some((field) => String(field.value || "").trim().length > 0);

    setAddToCartEnabled(addToCartButton, isComplete);
}

function getWritingBoxCanvas() {
    const writingBox = document.querySelector("writing-box");
    if (!writingBox || !writingBox.shadowRoot) {
        return null;
    }

    return writingBox.shadowRoot.querySelector("canvas");
}

function shouldUploadPreviewBeforeAddToCart() {
    const canvas = getWritingBoxCanvas();
    if (!canvas) {
        return false;
    }

    const personalizacion = document.querySelector(".personalizacion-fixed");
    const isPreviewVisible = personalizacion && personalizacion.style.display !== "none";
    if (isPreviewVisible) {
        return true;
    }

    const bcpo = document.getElementById("bcpo");
    return Boolean(bcpo && bcpo.style.display !== "none");
}

function canvasToPreviewFile(canvas) {
    return new Promise((resolve, reject) => {
        canvas.toBlob((blob) => {
            if (!blob) {
                reject(new Error("No se pudo generar la imagen de vista previa"));
                return;
            }

            const filename = `preview-${Date.now()}.png`;
            resolve(new File([blob], filename, { type: blob.type || "image/png" }));
        }, "image/png");
    });
}

async function uploadPreviewImageFile(file) {
    const formdata = new FormData();
    formdata.append("file", file, file.name);

    const response = await fetch(PREVIEW_IMAGE_UPLOAD_URL, {
        method: "POST",
        body: formdata
    });

    if (!response.ok) {
        throw new Error(`Error al subir la vista previa (${response.status})`);
    }

    const result = await response.json();
    if (!result || !result.url) {
        throw new Error("El servicio no devolvió una URL válida");
    }

    return result.url;
}

function ensurePreviewImagePropertyInput(form, url) {
    let input = form.querySelector(`input[name="${PREVIEW_IMAGE_PROPERTY_NAME}"]`);
    if (!input) {
        input = document.createElement("input");
        input.type = "hidden";
        input.name = PREVIEW_IMAGE_PROPERTY_NAME;
        form.appendChild(input);
    }

    input.value = url;
    return input;
}

function setAddToCartUploadState(button, isUploading, originalLabel) {
    if (!button) {
        return;
    }

    const textNode = button.querySelector("[data-product-atc-text]") || button;
    button.disabled = isUploading;
    button.classList.toggle("product-details__add-to-cart-button--loading", isUploading);

    if (isUploading) {
        textNode.textContent = PREVIEW_UPLOADING_LABEL;
        return;
    }

    if (typeof originalLabel === "string") {
        textNode.textContent = originalLabel;
    }
}

async function handlePreviewUploadBeforeAddToCart(event) {
    const button = event.target && event.target.closest ? event.target.closest("[data-product-atc]") : null;
    if (!button || button.disabled || isAddToCartSoldOut(button)) {
        return;
    }

    if (button.dataset.previewUploadBypass === "true") {
        delete button.dataset.previewUploadBypass;
        return;
    }

    if (!shouldUploadPreviewBeforeAddToCart()) {
        return;
    }

    const form = button.closest("form");
    const canvas = getWritingBoxCanvas();
    if (!form || !canvas) {
        return;
    }

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (isUploadingPreviewImage) {
        return;
    }

    isUploadingPreviewImage = true;
    const textNode = button.querySelector("[data-product-atc-text]") || button;
    const originalLabel = String(textNode.textContent || "").trim();
    setAddToCartUploadState(button, true, originalLabel);

    try {
        const file = await canvasToPreviewFile(canvas);
        const url = await uploadPreviewImageFile(file);
        ensurePreviewImagePropertyInput(form, url);

        isUploadingPreviewImage = false;
        setAddToCartUploadState(button, false, originalLabel);
        button.dataset.previewUploadBypass = "true";
        button.click();
    } catch (error) {
        console.error(error);
        isUploadingPreviewImage = false;
        setAddToCartUploadState(button, false, originalLabel);
        window.alert(PREVIEW_UPLOAD_ERROR_MESSAGE);
    }
}

document.addEventListener("click", handlePreviewUploadBeforeAddToCart, true);

function updateSideFieldFeedback(field) {
    if (!field) {
        return;
    }

    const inputContainer = getFieldInputContainer(field);
    const feedback = inputContainer ? inputContainer.querySelector("[data-bcpo-side-feedback='true']") : null;
    if (!feedback) {
        return;
    }

    const counter = feedback.querySelector("[data-bcpo-side-counter='true']");
    const maxLength = Number(field.getAttribute("maxlength") || SIDE_FIELD_MAX_LENGTH);
    const currentLength = String(field.value || "").length;

    if (counter) {
        counter.textContent = `${currentLength}/${maxLength}`;
    }
}

function ensureSideFieldFeedback(scope) {
    const wrappers = getSideFieldWrappers(scope);
    if (!wrappers.length) {
        return;
    }

    wrappers.forEach((wrapper) => {
        const field = getEditableFieldFromWrapper(wrapper);
        if (!field) {
            return;
        }

        const inputContainer = getFieldInputContainer(field);
        if (!inputContainer) {
            return;
        }

        if (!field.hasAttribute("maxlength")) {
            field.setAttribute("maxlength", String(SIDE_FIELD_MAX_LENGTH));
        }

        if (inputContainer.querySelector("[data-bcpo-side-feedback='true']")) {
            updateSideFieldFeedback(field);
            return;
        }

        inputContainer.classList.add("bcpo-side-feedback-anchor");

        const feedback = document.createElement("div");
        feedback.className = "bcpo-side-feedback";
        feedback.setAttribute("data-bcpo-side-feedback", "true");
        feedback.innerHTML = `
            <span class="bcpo-side-feedback__limit">Hasta 9 letras</span>
            <span class="bcpo-side-feedback__counter" data-bcpo-side-counter="true">0/9</span>
        `;

        inputContainer.appendChild(feedback);
        updateSideFieldFeedback(field);
    });
}

function getFontVariantById(variantId) {
    return SIDE_FIELD_FONT_VARIANTS.find((variant) => variant.id === variantId) || SIDE_FIELD_FONT_VARIANTS[0];
}

function getBcpoScopeFromNode(node) {
    if (!node) {
        return document.getElementById("bcpo");
    }

    return node.closest("#bcpo") || document.getElementById("bcpo");
}

function setActiveFontOption(selector, selectedVariantId) {
    if (!selector) {
        return;
    }

    Array.from(selector.querySelectorAll(".bcpo-font-selector__button")).forEach((button) => {
        const isActive = button.dataset.fontVariantId === selectedVariantId;
        button.classList.toggle("is-active", isActive);
        button.setAttribute("aria-pressed", isActive ? "true" : "false");
    });
}

function applyFontVariantToField(field, selector, variant, options = {}) {
    if (!field || !variant) {
        return;
    }

    const { dispatchEvents = true } = options;
    const previousVariantId = field.dataset.selectedFontVariant || "";
    const previewStyle = variant.previewStyle || "normal";
    field.style.fontFamily = withSymbolFont(variant.previewFamily);
    field.style.fontStyle = previewStyle;
    field.dataset.selectedFontVariant = variant.id;
    field.dataset.selectedFontFamily = variant.previewFamily;
    field.dataset.selectedFontStyle = previewStyle;
    field.setAttribute("data-selected-font-name", variant.name);
    syncFieldCasingForSelectedFont(field);
    setActiveFontOption(selector, variant.id);

    if (!dispatchEvents || previousVariantId === variant.id) {
        return;
    }

    field.dispatchEvent(new Event("input", { bubbles: true }));
    field.dispatchEvent(new Event("change", { bubbles: true }));
}

function getBcpoNativeFontSelect(scope) {
    if (!scope) {
        return null;
    }

    const selects = Array.from(scope.querySelectorAll("select"));
    return selects.find((select) => {
        const name = String(select.name || "").toLowerCase();
        if (/properties\s*\[\s*font/.test(name) || /font\s*\(ver/.test(name)) {
            return true;
        }

        const optionText = Array.from(select.options)
            .map((option) => String(option.textContent || option.value || "").toLowerCase())
            .join(" ");
        return /font\s*#\s*\d/.test(optionText);
    }) || null;
}

function getNativeFontOptionValue(select, variantId) {
    if (!select || !variantId) {
        return "";
    }

    const match = String(variantId).match(/(\d+)/);
    const fontNumber = match ? match[1] : "";
    if (!fontNumber) {
        return "";
    }

    const options = Array.from(select.options);
    const matchedOption = options.find((option) => {
        const label = String(option.textContent || option.value || "").toLowerCase().trim();
        return new RegExp(`(?:^|\\s)font\\s*#\\s*${fontNumber}(?:\\s|$)`).test(label)
            || new RegExp(`(?:^|\\s)#\\s*${fontNumber}(?:\\s|$)`).test(label)
            || label === `font-${fontNumber}`
            || label === fontNumber;
    });

    if (!matchedOption) {
        return "";
    }

    return matchedOption.value || String(matchedOption.textContent || "").trim();
}

function syncBcpoNativeFontSelect(scope, variantId) {
    const select = getBcpoNativeFontSelect(scope);
    if (!select) {
        return;
    }

    const nextValue = getNativeFontOptionValue(select, variantId || sharedSideFieldFontVariantId);
    if (!nextValue || select.value === nextValue) {
        return;
    }

    select.value = nextValue;

    if (select.value !== nextValue) {
        const matchedOption = Array.from(select.options).find((option) => {
            const optionValue = option.value || String(option.textContent || "").trim();
            return optionValue === nextValue;
        });
        if (matchedOption) {
            matchedOption.selected = true;
        }
    }

    select.dispatchEvent(new Event("input", { bubbles: true }));
    select.dispatchEvent(new Event("change", { bubbles: true }));
}

function ensureBcpoFontSelectHiddenAndSynced(scope) {
    if (!scope) {
        return;
    }

    const select = getBcpoNativeFontSelect(scope);
    if (!select) {
        return;
    }

    const wrapper = select.closest(".selector-wrapper, .bcpo-field, .bcpo-option, .form-field") || select.parentElement;
    if (wrapper) {
        wrapper.classList.add("bcpo-native-font-select--hidden");
        wrapper.setAttribute("data-bcpo-native-font-select", "true");
        wrapper.setAttribute("aria-hidden", "true");
    }

    select.setAttribute("data-bcpo-native-font-select-field", "true");
    select.removeAttribute("required");
    select.tabIndex = -1;

    syncBcpoNativeFontSelect(scope, sharedSideFieldFontVariantId);
}

function getSharedFontSelector(scope) {
    if (!scope) {
        return null;
    }

    return scope.querySelector("[data-bcpo-shared-font-selector='true']")
        || scope.querySelector("[data-bcpo-font-selector='true']");
}

function applySharedFontVariant(variant, scope) {
    if (!variant) {
        return;
    }

    sharedSideFieldFontVariantId = variant.id;
    const bcpoScope = scope || document.getElementById("bcpo");
    const wrappers = getSideFieldWrappers(bcpoScope);
    const sharedSelector = getSharedFontSelector(bcpoScope);

    wrappers.forEach((wrapper) => {
        const field = getEditableFieldFromWrapper(wrapper);
        if (!field) {
            return;
        }

        applyFontVariantToField(field, sharedSelector, variant);
    });

    setActiveFontOption(sharedSelector, variant.id);
    ensureBcpoFontSelectHiddenAndSynced(bcpoScope);
}

function buildFontSelector(field) {
    const selector = document.createElement("div");
    selector.className = "bcpo-font-selector";
    selector.setAttribute("data-bcpo-font-selector", "true");
    selector.setAttribute("data-bcpo-shared-font-selector", "true");
    selector.setAttribute("role", "group");
    selector.setAttribute("aria-label", "Escoger fuente:");

    const title = document.createElement("div");
    title.className = "bcpo-font-selector__title";
    title.textContent = "Escoger fuente:";
    selector.appendChild(title);

    const options = document.createElement("div");
    options.className = "bcpo-font-selector__options";

    SIDE_FIELD_FONT_VARIANTS.forEach((variant, index) => {
        const button = document.createElement("button");
        button.type = "button";
        button.className = "bcpo-font-selector__button";
        button.dataset.fontVariantId = variant.id;
        button.textContent = index === 1 ? "AA" : "Aa";
        button.title = variant.name;
        button.setAttribute("aria-label", `Ver texto con ${variant.name}`);
        button.style.fontFamily = variant.previewFamily;
        button.style.fontStyle = variant.previewStyle || "normal";
        button.addEventListener("click", () => {
            applySharedFontVariant(variant, getBcpoScopeFromNode(field));
        });
        options.appendChild(button);
    });

    selector.appendChild(options);
    setActiveFontOption(selector, sharedSideFieldFontVariantId);
    return selector;
}

function getOrCreateActionsGroup(wrapper) {
    if (!wrapper) {
        return null;
    }

    let group = wrapper.querySelector("[data-bcpo-actions-group='true']");
    if (group) {
        return group;
    }

    group = document.createElement("div");
    group.className = "bcpo-actions-group";
    group.setAttribute("data-bcpo-actions-group", "true");
    wrapper.appendChild(group);
    return group;
}

function ensureFontSelectorsNearSideLabels(scope) {
    const wrappers = getSideFieldWrappers(scope);
    if (!wrappers.length || !scope) {
        return;
    }

    // Un solo selector compartido: quitar duplicados por cada lado.
    wrappers.forEach((wrapper) => {
        Array.from(wrapper.querySelectorAll("[data-bcpo-font-selector='true']")).forEach((selector) => {
            selector.remove();
        });
    });

    const firstWrapper = wrappers[0];
    const field = getEditableFieldFromWrapper(firstWrapper);
    if (!field || !firstWrapper.parentNode) {
        return;
    }

    let selector = getSharedFontSelector(scope);
    const needsRebuild = !selector
        || !selector.isConnected
        || !selector.querySelector(".bcpo-font-selector__title")
        || !selector.querySelector(".bcpo-font-selector__options");

    if (needsRebuild) {
        if (selector && selector.isConnected) {
            selector.remove();
        }
        selector = buildFontSelector(field);
    }

    if (selector.nextElementSibling !== firstWrapper) {
        firstWrapper.parentNode.insertBefore(selector, firstWrapper);
    }

    applySharedFontVariant(getFontVariantById(sharedSideFieldFontVariantId), scope);
}

function showFieldTooltip(field, message) {
    const wrapper = getFieldWrapper(field);
    if (!wrapper) {
        return;
    }

    let tooltip = wrapper.querySelector("[data-bcpo-side-tooltip='true']");
    if (!tooltip) {
        tooltip = document.createElement("div");
        tooltip.className = "bcpo-side-tooltip";
        tooltip.setAttribute("data-bcpo-side-tooltip", "true");
        wrapper.appendChild(tooltip);
    }

    tooltip.textContent = message;
    tooltip.classList.add("is-visible");

    if (tooltip.hideTimeoutId) {
        window.clearTimeout(tooltip.hideTimeoutId);
    }

    tooltip.hideTimeoutId = window.setTimeout(() => {
        tooltip.classList.remove("is-visible");
    }, 3200);
}

function stripSideFieldSymbols(value) {
    return SIDE_FIELD_SYMBOLS.reduce((result, symbol) => result.split(symbol).join(""), String(value || ""));
}

function getSideFieldSymbols(value) {
    const normalizedValue = String(value || "");
    return SIDE_FIELD_SYMBOLS.filter((symbol) => normalizedValue.includes(symbol));
}

function encodeSideFieldValueForShopify(value) {
    return Array.from(String(value || ""))
        .map((character) => SIDE_FIELD_SYMBOL_SHOPIFY_CODES[character] || character)
        .join("");
}

function decodeSideFieldValueForDisplay(value) {
    return Array.from(String(value || ""))
        .map((character) => {
            const upperCharacter = character.toLocaleUpperCase("es-ES");
            return SIDE_FIELD_SHOPIFY_CODE_SYMBOLS[upperCharacter] || character;
        })
        .join("");
}

function getSideFieldPropertyName(field) {
    if (!field) {
        return "";
    }

    return String(field.dataset.bcpoPropertyName || field.name || "").trim();
}

function getSideFieldShopifyMirror(field) {
    if (!field) {
        return null;
    }

    if (field._bcpoShopifyMirror && field._bcpoShopifyMirror.isConnected) {
        return field._bcpoShopifyMirror;
    }

    const propertyName = getSideFieldPropertyName(field);
    if (!propertyName) {
        return null;
    }

    const wrapper = getFieldWrapper(field);
    const scope = wrapper || field.parentNode || document;
    const mirror = Array.from(scope.querySelectorAll("input[data-bcpo-side-shopify='true']"))
        .find((input) => input.name === propertyName) || null;
    if (mirror) {
        field._bcpoShopifyMirror = mirror;
    }

    return mirror;
}

function syncSideFieldShopifyMirror(field) {
    if (!field) {
        return;
    }

    const mirror = getSideFieldShopifyMirror(field) || ensureSideFieldShopifyMirror(field);
    if (!mirror) {
        return;
    }

    mirror.value = encodeSideFieldValueForShopify(field.value);
}

function ensureSideFieldShopifyMirror(field) {
    if (!field) {
        return null;
    }

    const propertyName = getSideFieldPropertyName(field) || String(field.name || "").trim();
    if (!propertyName || !/properties\[\s*lado\s*\d+/i.test(propertyName)) {
        return null;
    }

    field.dataset.bcpoSideVisual = "true";
    field.dataset.bcpoPropertyName = propertyName;

    const formScope = field.closest("form") || field.closest("#bcpo") || document;
    const existingMirrors = Array.from(formScope.querySelectorAll("input[data-bcpo-side-shopify='true']"))
        .filter((input) => input.name === propertyName);

    let mirror = existingMirrors[0] || null;
    existingMirrors.slice(1).forEach((extraMirror) => {
        if (extraMirror !== field) {
            extraMirror.remove();
        }
    });

    if (!mirror) {
        mirror = document.createElement("input");
        mirror.type = "hidden";
        mirror.setAttribute("data-bcpo-side-shopify", "true");
        field.insertAdjacentElement("afterend", mirror);
    }

    mirror.name = propertyName;
    mirror.type = "hidden";
    mirror.setAttribute("data-bcpo-side-shopify", "true");
    field._bcpoShopifyMirror = mirror;

    if (field.name === propertyName) {
        field.removeAttribute("name");
    }

    // Evita que otro input visible con el mismo name envíe iconos PUA al carrito.
    Array.from(formScope.querySelectorAll("input, textarea"))
        .filter((input) => input !== mirror && input !== field && input.name === propertyName)
        .forEach((duplicate) => {
            duplicate.removeAttribute("name");
            if (!duplicate.dataset.bcpoSideVisual) {
                duplicate.dataset.bcpoSideVisual = "true";
                duplicate.dataset.bcpoPropertyName = propertyName;
            }
        });

    mirror.value = encodeSideFieldValueForShopify(field.value);
    return mirror;
}

function ensureSideFieldShopifyMirrors(scope) {
    const wrappers = getSideFieldWrappers(scope);
    if (!wrappers.length) {
        return;
    }

    wrappers.forEach((wrapper) => {
        const field = getEditableFieldFromWrapper(wrapper);
        if (!field) {
            return;
        }

        ensureSideFieldShopifyMirror(field);
    });
}

function enhanceSideFieldPropertyDisplays(scope) {
    const root = scope && scope.querySelectorAll ? scope : document;
    const propertyValues = Array.from(root.querySelectorAll(".cart-item-property, .order-item-property"));

    propertyValues.forEach((propertyRow) => {
        const label = propertyRow.querySelector(".cart-item-property-label, .order-item-property-label");
        const valueNode = propertyRow.querySelector(".cart-item-property-value, .order-item-property-value");
        if (!label || !valueNode || valueNode.dataset.sideSymbolsEnhanced === "true") {
            return;
        }

        if (!/lado\s*\d+.*s[ií]mbolo/i.test(label.textContent || "")) {
            return;
        }

        const rawValue = String(valueNode.textContent || "");
        const decodedValue = decodeSideFieldValueForDisplay(rawValue);
        if (decodedValue === rawValue) {
            return;
        }

        // Solo decodifica cuando el valor es puramente códigos I/C/H/P (sin texto mixto ambiguo).
        const codesOnly = /^[ICHP]+$/i.test(rawValue.trim());
        if (!codesOnly) {
            return;
        }

        valueNode.textContent = decodedValue;
        valueNode.dataset.sideSymbolsEnhanced = "true";
        valueNode.classList.add("side-field-symbol-value");
    });
}

function getLastTextCharacterIndex(value) {
    const normalizedValue = String(value || "");

    for (let index = normalizedValue.length - 1; index >= 0; index -= 1) {
        const currentCharacter = normalizedValue[index];
        if (!SIDE_FIELD_SYMBOLS.includes(currentCharacter) && currentCharacter.trim()) {
            return index;
        }
    }

    return -1;
}

function isComfortaaFontSelected(field) {
    return Boolean(field && field.dataset.selectedFontVariant === COMFORTAA_FONT_VARIANT_ID);
}

function mergeSideFieldPrevState(prevValue, nextValue) {
    const prevChars = Array.from(String(prevValue || ""));
    const nextChars = Array.from(String(nextValue || ""));
    const prevUpper = prevChars.map((character) => character.toLocaleUpperCase("es-ES")).join("");
    const nextUpper = nextChars.map((character) => character.toLocaleUpperCase("es-ES")).join("");

    if (nextUpper === prevUpper) {
        return prevChars.join("");
    }

    if (nextUpper.startsWith(prevUpper)) {
        return prevChars.join("") + nextChars.slice(prevChars.length).join("");
    }

    if (prevUpper.startsWith(nextUpper)) {
        return prevChars.slice(0, nextChars.length).join("");
    }

    return nextChars.map((character, index) => {
        const prevCharacter = prevChars[index];
        if (prevCharacter && prevCharacter.toLocaleUpperCase("es-ES") === character.toLocaleUpperCase("es-ES")) {
            return prevCharacter;
        }
        return character;
    }).join("");
}

function restoreSideFieldPrevState(field) {
    if (!field || typeof field._bcpoPrevState !== "string") {
        return;
    }

    const restoredValue = field._bcpoPrevState;
    delete field._bcpoPrevState;

    if (String(field.value || "") === restoredValue) {
        return;
    }

    const selectionStart = typeof field.selectionStart === "number" ? field.selectionStart : null;
    const selectionEnd = typeof field.selectionEnd === "number" ? field.selectionEnd : null;
    field.value = restoredValue;

    if (selectionStart !== null && typeof field.setSelectionRange === "function") {
        try {
            const maxPosition = restoredValue.length;
            field.setSelectionRange(Math.min(selectionStart, maxPosition), Math.min(selectionEnd, maxPosition));
        } catch (error) {
            // Ignore selection errors on unsupported field types.
        }
    }

    syncSideFieldShopifyMirror(field);
}

function syncFieldCasingForSelectedFont(field) {
    if (!field) {
        return;
    }

    if (!isComfortaaFontSelected(field)) {
        field.style.textTransform = "";
        restoreSideFieldPrevState(field);
        return;
    }

    field.style.textTransform = "uppercase";

    const currentValue = String(field.value || "");
    const upperValue = currentValue.toLocaleUpperCase("es-ES");

    // Conserva la versión original (casing) antes de forzar mayúsculas.
    if (currentValue !== upperValue) {
        field._bcpoPrevState = currentValue;
    } else if (typeof field._bcpoPrevState === "string") {
        field._bcpoPrevState = mergeSideFieldPrevState(field._bcpoPrevState, currentValue);
    } else {
        field._bcpoPrevState = currentValue;
    }

    if (currentValue === upperValue) {
        return;
    }

    const selectionStart = typeof field.selectionStart === "number" ? field.selectionStart : null;
    const selectionEnd = typeof field.selectionEnd === "number" ? field.selectionEnd : null;
    field.value = upperValue;

    if (selectionStart !== null && typeof field.setSelectionRange === "function") {
        try {
            field.setSelectionRange(selectionStart, selectionEnd);
        } catch (error) {
            // Ignore selection errors on unsupported field types.
        }
    }

    syncSideFieldShopifyMirror(field);
}

function sanitizeSideFieldValue(field) {
    if (!field) {
        return;
    }

    syncFieldCasingForSelectedFont(field);

    const rawValue = String(field.value || "");
    const selectedSymbols = getSideFieldSymbols(rawValue);
    const textOnlyValue = stripSideFieldSymbols(rawValue);
    const hasSymbol = selectedSymbols.length > 0;
    const hasText = textOnlyValue.trim().length > 0;

    if (!hasSymbol) {
        field.dataset.entryMode = hasText ? "text" : "";
        syncSideFieldShopifyMirror(field);
        return;
    }

    if (!hasText) {
        field.dataset.entryMode = "symbol";
        syncSideFieldShopifyMirror(field);
        return;
    }

    field.dataset.entryMode = "mixed";
    syncSideFieldShopifyMirror(field);
}

function insertEmojiIntoField(field, emoji) {
    if (!field) {
        return;
    }

    const currentValue = String(field.value || "");
    const selectionStart = typeof field.selectionStart === "number" ? field.selectionStart : currentValue.length;
    const selectionEnd = typeof field.selectionEnd === "number" ? field.selectionEnd : currentValue.length;
    const nextValue = `${currentValue.slice(0, selectionStart)}${emoji}${currentValue.slice(selectionEnd)}`;

    field.value = nextValue;
    field.dataset.entryMode = currentValue.trim().length > 0 ? "mixed" : "symbol";
    syncSideFieldShopifyMirror(field);

    const nextCaretPosition = selectionStart + emoji.length;
    if (typeof field.setSelectionRange === "function") {
        field.setSelectionRange(nextCaretPosition, nextCaretPosition);
    }

    field.dispatchEvent(new Event("input", { bubbles: true }));
    field.dispatchEvent(new Event("change", { bubbles: true }));
    field.focus();
}

function buildEmojiSelector(field) {
    const selector = document.createElement("div");
    selector.className = "bcpo-emoji-selector";
    selector.setAttribute("data-bcpo-emoji-selector", "true");

    const title = document.createElement("div");
    title.className = "bcpo-emoji-selector__title";
    title.textContent = "AÑADIR SÍMBOLO:";
    selector.appendChild(title);

    SIDE_FIELD_SYMBOLS.forEach((symbol) => {
        const button = document.createElement("button");
        const symbolLabel = SIDE_FIELD_SYMBOL_LABELS[symbol] || "símbolo";
        button.type = "button";
        button.className = "bcpo-emoji-selector__button";
        button.textContent = symbol;
        button.title = symbolLabel;
        button.setAttribute("aria-label", `Agregar ${symbolLabel}`);
        button.addEventListener("click", () => {
            insertEmojiIntoField(field, symbol);
        });
        selector.appendChild(button);
    });

    return selector;
}

function ensureIconSelectorsNearSideFields(scope) {
    const wrappers = getSideFieldWrappers(scope);
    if (!wrappers.length) {
        return;
    }

    wrappers.forEach((wrapper) => {
        const field = getEditableFieldFromWrapper(wrapper);
        const actionGroup = getOrCreateActionsGroup(wrapper);
        if (!field || !actionGroup) {
            return;
        }

        let selector = wrapper.querySelector("[data-bcpo-emoji-selector='true']");
        if (!selector) {
            selector = buildEmojiSelector(field);
        }

        if (selector.parentNode !== actionGroup) {
            actionGroup.appendChild(selector);
        }

        ensureSideFieldShopifyMirror(field);
    });
}

function ensureActionsBeforeInput(scope) {
    const wrappers = getSideFieldWrappers(scope);
    if (!wrappers.length) {
        return;
    }

    wrappers.forEach((wrapper) => {
        const field = getEditableFieldFromWrapper(wrapper);
        const actionGroup = wrapper.querySelector("[data-bcpo-actions-group='true']");
        const inputContainer = field ? getFieldInputContainer(field) : null;
        if (!actionGroup || !inputContainer || inputContainer.parentNode !== wrapper) {
            return;
        }

        const labelContainer = wrapper.querySelector(".bcpo-label");
        if (labelContainer && labelContainer.parentNode === wrapper && inputContainer.previousElementSibling !== labelContainer) {
            wrapper.insertBefore(inputContainer, labelContainer.nextSibling);
        }

        if (actionGroup.previousElementSibling !== inputContainer) {
            if (inputContainer.nextSibling) {
                wrapper.insertBefore(actionGroup, inputContainer.nextSibling);
            } else {
                wrapper.appendChild(actionGroup);
            }
        }
    });
}

function bindPreviewOnSymbolInteraction(scope) {
    if (!scope || scope.dataset.writingBoxSymbolBound === "true") {
        return;
    }

    const showPreview = (event) => {
        const trigger = event.target && event.target.closest ? event.target.closest("select, button, div, label, input[type='radio']") : null;
        if (!trigger || !isSymbolControlElement(trigger)) {
            return;
        }

        verPersonalizacion();
    };

    scope.addEventListener("click", showPreview);
    scope.addEventListener("change", showPreview);
    scope.dataset.writingBoxSymbolBound = "true";
}

const TEXT_COLOR_DEFAULT = "#000000";
const TEXT_COLOR_GOLD_DARK = "#8B6914";

function getColorPatternForText() {
    try {
        if (typeof globalColorPatterForText === "undefined" || globalColorPatterForText == null) {
            return [];
        }

        if (typeof globalColorPatterForText === "string") {
            const trimmed = globalColorPatterForText.trim();
            if (!trimmed) {
                return [];
            }

            try {
                const parsed = JSON.parse(trimmed);
                return Array.isArray(parsed) ? parsed : [];
            } catch (error) {
                return [];
            }
        }

        return Array.isArray(globalColorPatterForText) ? globalColorPatterForText : [];
    } catch (error) {
        return [];
    }
}

function resolvePersonalizationTextColor() {
    const patterns = getColorPatternForText();
    const hasGold = patterns.some((entry) => {
        const label = entry && typeof entry.label === "string" ? entry.label : "";
        return label.toLocaleLowerCase("es-ES").includes("dorado");
    });

    return hasGold ? TEXT_COLOR_GOLD_DARK : TEXT_COLOR_DEFAULT;
}

class WritingBox extends HTMLElement {
    static get observedAttributes() {
        return ["type", "image-src", "values", "coordinates", "canvas-width", "canvas-height", "font-size", "font-family", "font-families"];
    }

    constructor() {
        super();
        this.attachShadow({ mode: "open" });
        this.canvas = null;
        this.ctx = null;
        this.baseImage = new Image();
        this.baseImage.crossOrigin = "anonymous";
        this.loadedImageSrc = "";
        this.propertyInputHandlers = [];
        this.propertyObserver = null;
        this.propertyBindRaf = null;
        this.propertyInputNames = [
            "properties[lado 1 (texto o símbolo)]",
            "properties[lado 2 (texto o símbolo)]",
            "properties[lado 3 (texto o símbolo)]",
            "properties[lado 4 (texto o símbolo)]"
        ];

        this.state = {
            type: "bracelet-flat",
            imageSrc: "",
            values: [],
            fontFamilies: [],
            coordinates: [],
            canvasWidth: 560,
            canvasHeight: 190,
            fontSize: 16,
            fontFamily: "Arial"
        };

        this.coordinatePresets = {
            "bracelet-flat": [
                { x: 100, y: 90, fontSize: 24, color: "#111111", textAlign: "center" },
                { x: 210, y: 90, fontSize: 24, color: "#111111", textAlign: "center" },
                { x: 320, y: 90, fontSize: 24, color: "#111111", textAlign: "center" },
                { x: 430, y: 90, fontSize: 24, color: "#111111", textAlign: "center" }
            ],
            "bracelet-curve": [
                { x: 115, y: 108, fontSize: 24, color: "#111111", textAlign: "center", rotate: -0.2 },
                { x: 215, y: 88, fontSize: 24, color: "#111111", textAlign: "center", rotate: -0.08 },
                { x: 325, y: 88, fontSize: 24, color: "#111111", textAlign: "center", rotate: 0.08 },
                { x: 425, y: 108, fontSize: 24, color: "#111111", textAlign: "center", rotate: 0.2 }
            ],
            "bracelet-stack": [
                { x: 145, y: 72, fontSize: 22, color: "#111111", textAlign: "left" },
                { x: 145, y: 110, fontSize: 22, color: "#111111", textAlign: "left" },
                { x: 320, y: 72, fontSize: 22, color: "#111111", textAlign: "left" },
                { x: 320, y: 110, fontSize: 22, color: "#111111", textAlign: "left" }
            ],
            "bracelet-preview-226x300": [
                { x: 110, y: 30, fontSize: 16, color: "#111111", textAlign: "center" },
                { x: 110, y: 115, fontSize: 16, color: "#111111", textAlign: "center" },
                { x: 110, y: 200, fontSize: 16, color: "#111111", textAlign: "center" },
                { x: 110, y: 284, fontSize: 16, color: "#111111", textAlign: "center" }
            ],
            "bracelet-preview-1x1": [
                { x: 192, y: 74, fontSize: 16, color: "#111111", textAlign: "center" },
                { x: 192, y: 167, fontSize: 16, color: "#111111", textAlign: "center" },
                { x: 192, y: 250, fontSize: 16, color: "#111111", textAlign: "center" },
                { x: 192, y: 342, fontSize: 16, color: "#111111", textAlign: "center" }
            ]
        };
    }

    connectedCallback() {
        this.syncStateFromAttributes();
        this.syncValuesFromPropertyInputs({ updateAttribute: true });
        this.syncFontFamiliesFromPropertyInputs({ updateAttribute: true });
        this.render();
        this.bindPropertyInputs();
        this.observePropertyInputs();
    }

    disconnectedCallback() {
        this.unbindPropertyInputs();
        if (this.propertyObserver) {
            this.propertyObserver.disconnect();
            this.propertyObserver = null;
        }

        if (this.propertyBindRaf) {
            cancelAnimationFrame(this.propertyBindRaf);
            this.propertyBindRaf = null;
        }
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (oldValue === newValue) {
            return;
        }

        this.syncStateFromAttributes();

        if (!this.shadowRoot || !this.canvas) {
            return;
        }

        if (name === "image-src") {
            this.drawPreview();
            return;
        }

        this.drawPreview();
    }

    syncStateFromAttributes() {
        const type = (this.getAttribute("type") || "bracelet-flat").trim();
        const imageSrc = (this.getAttribute("image-src") || "").trim();
        const valuesAttr = this.getAttribute("values");
        const coordinatesAttr = this.getAttribute("coordinates");
        const fontFamiliesAttr = this.getAttribute("font-families");
        const canvasWidthAttr = Number(this.getAttribute("canvas-width") || 560);
        const canvasHeightAttr = Number(this.getAttribute("canvas-height") || 190);
        const fontSizeAttr = Number(this.getAttribute("font-size") || 16);
        const fontFamilyAttr = (this.getAttribute("font-family") || "Arial").trim();

        const parsedValues = this.safeJsonParse(valuesAttr, []);
        const values = Array.isArray(parsedValues) ? parsedValues.map((v) => String(v ?? "")) : [];

        const parsedCoordinates = this.safeJsonParse(coordinatesAttr, null);
        const customCoordinates = Array.isArray(parsedCoordinates) ? parsedCoordinates : null;
        const parsedFontFamilies = this.safeJsonParse(fontFamiliesAttr, []);
        const fontFamilies = Array.isArray(parsedFontFamilies)
            ? parsedFontFamilies.map((fontEntry) => this.normalizeFontEntry(fontEntry))
            : [];

        this.state.type = type;
        this.state.imageSrc = imageSrc;
        this.state.values = values;
        this.state.fontFamilies = fontFamilies;
        this.state.coordinates = customCoordinates || this.getCoordinatesByType(type);
        this.state.canvasWidth = Number.isFinite(canvasWidthAttr) && canvasWidthAttr > 0 ? canvasWidthAttr : 560;
        this.state.canvasHeight = Number.isFinite(canvasHeightAttr) && canvasHeightAttr > 0 ? canvasHeightAttr : 190;
        this.state.fontSize = Number.isFinite(fontSizeAttr) && fontSizeAttr > 0 ? fontSizeAttr : 16;
        this.state.fontFamily = fontFamilyAttr || "Arial";
    }

    normalizeFontEntry(fontEntry) {
        if (fontEntry && typeof fontEntry === "object") {
            return {
                family: String(fontEntry.family || DEFAULT_SIDE_FIELD_FONT_FAMILY).trim() || DEFAULT_SIDE_FIELD_FONT_FAMILY,
                style: String(fontEntry.style || DEFAULT_SIDE_FIELD_FONT_STYLE).trim() || DEFAULT_SIDE_FIELD_FONT_STYLE
            };
        }

        return {
            family: String(fontEntry || DEFAULT_SIDE_FIELD_FONT_FAMILY).trim() || DEFAULT_SIDE_FIELD_FONT_FAMILY,
            style: DEFAULT_SIDE_FIELD_FONT_STYLE
        };
    }

    getCoordinatesByType(type) {
        const selected = this.coordinatePresets[type];
        if (selected && selected.length) {
            return selected;
        }
        return this.coordinatePresets["bracelet-flat"];
    }

    safeJsonParse(value, fallbackValue) {
        if (!value) {
            return fallbackValue;
        }

        try {
            return JSON.parse(value);
        } catch (error) {
            return fallbackValue;
        }
    }

    getSearchScope() {
        return this.closest("form") || document;
    }

    getPropertyFieldByName(name) {
        const scope = this.getSearchScope();
        const visualField = Array.from(scope.querySelectorAll("[data-bcpo-side-visual='true']"))
            .find((field) => field.dataset.bcpoPropertyName === name) || null;
        if (visualField) {
            return visualField;
        }

        const candidates = Array.from(scope.querySelectorAll("input, textarea, select"));
        return candidates.find((field) => field.name === name && field.dataset.bcpoSideShopify !== "true") ||
            candidates.find((field) => field.name === name) ||
            null;
    }

    getPropertyInputs() {
        return this.propertyInputNames
            .map((name) => this.getPropertyFieldByName(name))
            .filter(Boolean);
    }

    syncValuesFromPropertyInputs(options = {}) {
        const { updateAttribute = false } = options;
        const inputs = this.getPropertyInputs();
        if (!inputs.length) {
            return;
        }

        const values = this.propertyInputNames.map((name) => {
            const input = this.getPropertyFieldByName(name);
            return input ? String(input.value || "") : "";
        });

        this.state.values = values;

        if (updateAttribute) {
            this.setAttribute("values", JSON.stringify(values));
        }
    }

    syncFontFamiliesFromPropertyInputs(options = {}) {
        const { updateAttribute = false } = options;
        const inputs = this.getPropertyInputs();
        if (!inputs.length) {
            return;
        }

        const fontFamilies = this.propertyInputNames.map((name) => {
            const input = this.getPropertyFieldByName(name);
            const selectedFontFamily = input ? String(input.dataset.selectedFontFamily || "").trim() : "";
            const selectedFontStyle = input ? String(input.dataset.selectedFontStyle || "").trim() : "";
            return {
                family: selectedFontFamily || DEFAULT_SIDE_FIELD_FONT_FAMILY,
                style: selectedFontStyle || DEFAULT_SIDE_FIELD_FONT_STYLE
            };
        });

        this.state.fontFamilies = fontFamilies;

        if (updateAttribute) {
            this.setAttribute("font-families", JSON.stringify(fontFamilies));
        }
    }

    bindPropertyInputs() {
        this.unbindPropertyInputs();

        const syncAndRender = () => {
            this.syncValuesFromPropertyInputs({ updateAttribute: true });
            this.syncFontFamiliesFromPropertyInputs({ updateAttribute: true });
            this.drawPreview();
        };

        this.propertyInputNames.forEach((name) => {
            const input = this.getPropertyFieldByName(name);
            if (!input) {
                return;
            }

            const handler = () => {
                sanitizeSideFieldValue(input);
                updateSideFieldFeedback(input);
                syncAndRender();
                const bcpo = document.getElementById("bcpo");
                if (bcpo) {
                    updateAddToCartVisibility(bcpo);
                }
            };

            input.addEventListener("input", handler);
            input.addEventListener("change", handler);
            this.propertyInputHandlers.push({ input, handler });
        });
    }

    unbindPropertyInputs() {
        this.propertyInputHandlers.forEach(({ input, handler }) => {
            input.removeEventListener("input", handler);
            input.removeEventListener("change", handler);
        });
        this.propertyInputHandlers = [];
    }

    observePropertyInputs() {
        if (this.propertyObserver || !document.body) {
            return;
        }

        this.propertyObserver = new MutationObserver(() => {
            if (this.propertyBindRaf) {
                return;
            }

            this.propertyBindRaf = requestAnimationFrame(() => {
                this.propertyBindRaf = null;
                const bcpo = document.getElementById("bcpo");
                if (bcpo) {
                    ensureSideLabelSuffixHidden(bcpo);
                    ensurePropertyInputsNearSymbolControl(bcpo);
                    ensureSideFieldFeedback(bcpo);
                    ensureFontSelectorsNearSideLabels(bcpo);
                    ensureBcpoFontSelectHiddenAndSynced(bcpo);
                    ensureIconSelectorsNearSideFields(bcpo);
                    ensureSideFieldShopifyMirrors(bcpo);
                    ensureActionsBeforeInput(bcpo);
                    bindPreviewOnSymbolInteraction(bcpo);
                    updateAddToCartVisibility(bcpo);
                }
                this.bindPropertyInputs();
                this.syncValuesFromPropertyInputs({ updateAttribute: true });
                this.syncFontFamiliesFromPropertyInputs({ updateAttribute: true });
                this.drawPreview();
            });
        });

        this.propertyObserver.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    render() {
        const styles = `
            :host {
                display: block;
                width: 100%;
                max-width: 680px;
                margin: 0 auto;
                font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
            }

            .writing-box {
                display: grid;
                gap: 14px;
                grid-template-columns: 1fr;
            }

            .writing-box__canvas-wrap {
                position: relative;
                width: 100%;
                border: 1px solid #d9d9d9;
                border-radius: 8px;
                overflow: hidden;
                background: linear-gradient(180deg, #fafafa 0%, #f2f2f2 100%);
            }

            canvas {
                width: 100%;
                height: auto;
                display: block;
            }

        `;

        const html = `
            <div class="writing-box">
                <div class="writing-box__canvas-wrap">
                    <canvas width="${this.state.canvasWidth}" height="${this.state.canvasHeight}"></canvas>
                </div>
            </div>
        `;

        this.shadowRoot.innerHTML = `<style>${styles}</style>${html}`;
        this.canvas = this.shadowRoot.querySelector("canvas");
        this.ctx = this.canvas.getContext("2d");
        this.drawPreview();
    }

    drawPreview() {
        if (!this.ctx || !this.canvas) {
            return;
        }

        const paint = () => {
            if (!this.state.imageSrc) {
                this.loadedImageSrc = "";
                this.drawEmptyBase();
                this.drawTexts();
                return;
            }

            const drawLoadedImage = () => {
                this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
                this.ctx.drawImage(this.baseImage, 0, 0, this.canvas.width, this.canvas.height);
                this.drawTexts();
            };

            const imageAlreadyReady =
                this.loadedImageSrc === this.state.imageSrc &&
                this.baseImage.complete &&
                this.baseImage.naturalWidth > 0;

            if (imageAlreadyReady) {
                drawLoadedImage();
                return;
            }

            this.baseImage.onload = () => {
                this.loadedImageSrc = this.state.imageSrc;
                drawLoadedImage();
            };

            this.baseImage.onerror = () => {
                this.loadedImageSrc = "";
                this.drawEmptyBase();
                this.drawTexts();
            };

            if (this.baseImage.src && this.loadedImageSrc === this.state.imageSrc) {
                // Same src already assigned; force draw if browser skipped onload.
                if (this.baseImage.complete && this.baseImage.naturalWidth > 0) {
                    this.loadedImageSrc = this.state.imageSrc;
                    drawLoadedImage();
                }
                return;
            }

            this.baseImage.src = this.state.imageSrc;

            // Cached images can be complete immediately without firing onload.
            if (this.baseImage.complete && this.baseImage.naturalWidth > 0) {
                this.loadedImageSrc = this.state.imageSrc;
                drawLoadedImage();
            }
        };

        if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(paint).catch(paint);
            return;
        }

        paint();
    }

    drawEmptyBase() {
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        this.ctx.fillStyle = "#f6f6f6";
        this.ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
        this.ctx.strokeStyle = "#e0e0e0";
        this.ctx.strokeRect(0, 0, this.canvas.width, this.canvas.height);
    }

    resolveFontEntry(fontEntry, config = {}) {
        const normalized = this.normalizeFontEntry(fontEntry);
        const family = config.fontFamily || normalized.family || this.state.fontFamily;
        const style = config.fontStyle || normalized.style || DEFAULT_SIDE_FIELD_FONT_STYLE;
        return { family, style };
    }

    drawTexts() {
        const coordinates = this.state.coordinates || [];
        const values = this.state.values || [];
        const fontFamilies = this.state.fontFamilies || [];

        for (let index = 0; index < values.length; index += 1) {
            const config = coordinates[index];
            const rawText = values[index];

            if (!config || !rawText) {
                continue;
            }

            const {
                x = 0,
                y = 0,
                fontSize = this.state.fontSize,
                textAlign = "center",
                rotate = 0
            } = config;
            const color = resolvePersonalizationTextColor();
            const { family: fontFamily, style: fontStyle } = this.resolveFontEntry(fontFamilies[index], config);
            const text = String(fontFamily || "").includes("Comfortaa")
                ? String(rawText).toLocaleUpperCase("es-ES")
                : String(rawText);

            this.ctx.save();
            this.ctx.translate(x, y);
            if (rotate) {
                this.ctx.rotate(rotate);
            }
            this.ctx.font = `${fontStyle} ${fontSize}px ${withSymbolFont(fontFamily)}`;
            this.ctx.fillStyle = color;
            this.ctx.textAlign = textAlign;
            this.ctx.textBaseline = "middle";
            this.ctx.fillText(text, 0, 0);
            this.ctx.restore();
        }
    }

}

if (!customElements.get("writing-box")) {
    customElements.define("writing-box", WritingBox);
}



